import React, { useEffect } from "react";
import { unstable_HistoryRouter as HistoryRouter, Routes, Route, Navigate } from "react-router-dom";
import history from "./utils/history";
import MyMarkets from "./pages/rankSummary/myMarkets";
import PublicLayout from "./layouts/PublicLayout";
import Signup from "./pages/public/Signup";
import { initAnalytics } from "./analytics/analytics";
import RouteTracker from "./analytics/RouteTracker";
import EmailVerification from "./pages/public/EmailVerification";

const PublicApp = () => {
  useEffect(() => {
    initAnalytics();
  }, []);

  return (<HistoryRouter history={history}>
    <RouteTracker />

    <Routes>
      <Route
        path="/public/first-to-worst"
        element={
          <PublicLayout>
            <MyMarkets />
          </PublicLayout>
        }
      />
      <Route
        path="/signup"
        element={
          <PublicLayout>
            <Signup />
          </PublicLayout>
        }
      />
      <Route
        path="/signup/email-verification"
        element={
          <PublicLayout>
            <EmailVerification />
          </PublicLayout>
        }
      />
    </Routes>
  </HistoryRouter>)
}


export default PublicApp;
